// ***********************************
import * as React from 'react';
import {observable,action} from 'mobx';
import {inject,observer} from 'mobx-react';
import {IStores,IStoresInject,IEvent} from '../../../../Types/interfaces';
import MoreRightVector from '../../../SVG/moreright';
// ***********************************
interface IProps extends IStoresInject {
  item: IEvent|null;
  continues: boolean;
  orientStyle: {};
}
// ***********************************
@inject((stores: IStores): IStoresInject => ({...stores}))
@observer export default class OrientRight extends React.Component<IProps,{}> {
  //***********************
  @observable hover: boolean;
  //***********************
  constructor(props: IProps) {
    super(props);
    this._construct();
  }
  //***********************
  @action private _construct() {
    this.hover=false;
  }
  //***********************
  @action handleMouseEnter=(): void => {this.hover=true;};
  @action handleMouseLeave=(): void => {this.hover=false;};
  //***********************
  navigateToEnd=(e: React.FormEvent<HTMLElement>): boolean => {
    const {frame,item}=this.props;
    e.stopPropagation();
    let milliDur=item!.DurationMinutes*60*1000;
    frame!.setEnd(item!.startTime.valueOf()+milliDur);
    return false;
  }
  //***********************
  render() {
    const {proto,continues,item}=this.props;

    let rightColor=proto!.hoverableColor(this.hover,true);
    return (
      <div style={this.props.orientStyle}>
        {item!.EventId!==0&&continues? <div style={{padding: '5px',overflow: 'hidden',minWidth: '15px'}} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} onClick={this.navigateToEnd}>
          <MoreRightVector color={rightColor} width={8.5} />
        </div>:''}
      </div>
    );
  }
  //***********************
}